declare global {
  interface ErrorConstructor {
    captureStackTrace(thisArg: any, func: any): void;
  }
}

export class HandledError extends Error {
  constructor(...params) {
    super(...params);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, HandledError);
    }
  }
}
